/* eslint-disable react/jsx-no-target-blank */
import { BrandLocations } from "app/brands/components/BrandLocations"
import { BrandMetadataPanel } from "app/brands/components/BrandMetadataPanel"
import { card, colWide } from "app/common/components/Containers"
import { GooglePlacePhotos } from "app/common/components/GooglePlacePhotos"
import { StructuredText } from "app/common/components/StructuredText"
import { optionalRender } from "app/common/ui/optionalRender"
import { variantsToSrcSet } from "app/common/utilities/html"
import { StructuredTextEntities } from "app/common/utilities/structuredText"
import { LocationD } from "app/data/location/location.types"
import { BrandVM } from "app/models"
import { LocaleD } from "db"
import { array } from "fp-ts"
import { pipe } from "fp-ts/function"
import React from "react"
import { tw } from "twind"

interface BrandDetailsProps {
  brand: BrandVM
  entities: StructuredTextEntities
  locale: LocaleD
}

export const BrandDetails = ({ brand, entities, locale }: BrandDetailsProps) => {
  return (
    <div className={tw(`flex(& col md:row) gap-10 items-start`)}>
      <div className={tw(`flex(& col 1) gap-3`, `rounded-xl`, `mb-0`, `mt-2`)}>
        <h1 className={tw(`text-2xl font-bold`, `mb-4 pb-3`, `border(b-1 gray-300)`)}>
          {brand.name}
        </h1>

        <StructuredText data={brand.content} entities={entities} />
        {(array.isNonEmpty(brand.images) || brand.showPlacePhotos) && (
          <div className={tw(colWide, card, `flex(& col) gap-2`)}>
            {brand.showPlacePhotos &&
              array.isNonEmpty(brand.locations) &&
              pipe(
                brand.locations,
                array.map((location: LocationD) =>
                  pipe(
                    location.place_id,
                    optionalRender((place_id) => (
                      <GooglePlacePhotos key={place_id} placeId={place_id} />
                    ))
                  )
                )
              )}

            <ul className={tw(`ram(xs sm:sm)`)}>
              {pipe(
                brand.images,
                array.mapWithIndex((index, image) => (
                  <li className={tw(card)} key={image.url}>
                    <img
                      alt={image.alternateText}
                      height={image.height}
                      loading={index > 10 ? "lazy" : undefined}
                      sizes={"400px"}
                      src={image.url}
                      srcSet={variantsToSrcSet(image.variants)}
                      width={image.width}
                    />
                  </li>
                ))
              )}
            </ul>
          </div>
        )}
        {array.isNonEmpty(brand.locations) && <BrandLocations brand={brand} />}
      </div>

      <BrandMetadataPanel brand={brand} locale={locale} />
    </div>
  )
}
